import React from 'react';
import { Typography } from '@material-ui/core';
import { Alert, AlertTitle } from '@material-ui/lab';
import { PageError } from '../extensions/PageError';
import { getAppInsights } from '../TelemetryService';
import { SeverityLevel } from '@microsoft/applicationinsights-web';
import PaperColumn from './PaperColumn';
import MessageList from './MessageList';
import { useMount } from '../hooks/useMount';

export interface ErrorMessageProps {
  data: PageError;
}

export const ErrorMessage: React.FunctionComponent<ErrorMessageProps> = (props) => {
  const { data } = props;

  useMount(() => {
       getAppInsights().trackException({ error: data, severityLevel: SeverityLevel.Error });
    });

  console.error(data);

  delete data.attributes.Status;

  return (
    <PaperColumn>
      <Alert severity="error">
        <AlertTitle><Typography variant="h5">Error</Typography></AlertTitle>
        <Typography>{data.message}</Typography>
        <MessageList messagesObject={data.attributes} />
      </Alert>
    </PaperColumn>
  );
};